import {Component, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Portal, TranslationEntry} from "../../../../../backend";
import {LocaleService} from "../../../service/locale.service";
import {PortalEnvironmentService} from "../../../service/portal-environment.service";


@Component({
  selector: 'app-abstract-portal',
  standalone: true,
  imports: [CommonModule],
  template: '',
})
export abstract class AbstractPortalComponent {


  private portalEnvironmentService: PortalEnvironmentService;

  constructor(protected localeService: LocaleService) {
    this.portalEnvironmentService = inject(PortalEnvironmentService);

  }

  public isPortalExist(): boolean {
    return this.portalEnvironmentService.isPortalExist();
  }

  public getPortal(): Portal {
    return this.portalEnvironmentService.getPortal();
  }

  public getPortalId(): number | undefined {
    let portal = this.portalEnvironmentService.getPortal() as Portal;
    if (portal === undefined) {
      return undefined;
    }
    return portal.id!;
  }

  public getLocale(): string {
    return this.localeService.currentLocale;
  }

  public getPortalLanguages(): string[] {
    if (this.getPortal() === undefined || this.getPortal().languages === undefined) {
      return [];
    }
    // @ts-ignore
    return this.getPortal().languages.map(x => x.lang)
  }

  public getServerBackend() {
    if (this.portalEnvironmentService.SERVER_URL === undefined || this.portalEnvironmentService.SERVER_URL === '') {
      return window.location.protocol + "//" + window.location.host;
    }
    return this.portalEnvironmentService.SERVER_URL;
  }

  public getLoginUrl() {
    const loginUrl = new URL('/app/auth/login', window.location.origin);
    const returnTo = window.location.pathname + window.location.search + window.location.hash;

    loginUrl.searchParams.set('returnTo', returnTo);
    loginUrl.searchParams.set('language', this.localeService.currentLocale);

    return loginUrl.toString();
  }


  public isLoggedUser() {
    return this.portalEnvironmentService._user !== undefined;
  }

  public logoutUser() {
    this.portalEnvironmentService.logoutUser();
  }

  public getUser() {
    return this.portalEnvironmentService._user;
  }

  public reloadUser() {
    this.portalEnvironmentService.reloadUser();
  }

  public getPortalTitle() {

    let portal = this.getPortal();
    if (portal === undefined || portal.data === undefined || portal.data.titles === undefined) {
      return undefined;
    }
    let entries: TranslationEntry[] = portal.data.titles.filter(x => x.language === this.getLocale());
    if (entries !== undefined && entries.length > 0) {
      return entries[0].entry;
    }
    entries = portal.data.titles.filter(x => x.language === "en");
    if (entries !== undefined && entries.length > 0) {
      return entries[0].entry;
    }
    return portal.data.titles[0].entry;
  }

  public getPortalDescription() {

    let portal = this.getPortal();
    if (portal === undefined || portal.data === undefined || portal.data.descriptions === undefined) {
      return undefined;
    }
    let entries: TranslationEntry[] = portal.data.descriptions.filter(x => x.language === this.getLocale());
    if (entries !== undefined && entries.length > 0) {
      return entries[0].entry;
    }
    entries = portal.data.descriptions.filter(x => x.language === "en");
    if (entries !== undefined && entries.length > 0) {
      return entries[0].entry;
    }
    return portal.data.descriptions[0].entry;
  }

  public getPortalKeywords() {
    let portal = this.getPortal();
    if (portal === undefined || portal.data === undefined || portal.data.keywords === undefined) {
      return undefined;
    }
    let entries: TranslationEntry[] = portal.data.keywords.filter(x => x.language === this.getLocale());
    if (entries !== undefined && entries.length > 0) {
      return entries[0].entry;
    }
    entries = portal.data.keywords.filter(x => x.language === "en");
    if (entries !== undefined && entries.length > 0) {
      return entries[0].entry;
    }
    return portal.data.keywords[0].entry;
  }

}


